import type { CustomerAddressFormValue } from "@/modules/customers/domain/address";
import { useShippingBranchOptionsQuery } from "@/modules/orders/presentation/api/queries";
import { SuggestTextField } from "@/shared/ui/SuggestTextField";

type ShippingBranchFieldProps = {
  id: string;
  value: string;
  onChange: (next: string) => void;
  carrier: string;
  address: Pick<CustomerAddressFormValue, "province" | "district" | "village">;
  disabled?: boolean;
};

export function ShippingBranchField({
  id,
  value,
  onChange,
  carrier,
  address,
  disabled = false,
}: ShippingBranchFieldProps) {
  const carrierValue = carrier.trim();
  const branchQ = value.trim();
  const province = address.province.trim();
  const district = address.district.trim();
  const village = address.village.trim();

  const options = useShippingBranchOptionsQuery(
    {
      carrier: carrierValue,
      province: province || undefined,
      district: district || undefined,
      village: village || undefined,
      q: branchQ || undefined,
    },
    Boolean(carrierValue),
  );

  const placeholder = !carrierValue
    ? "ເລືອກຂົນສົ່ງກ່ອນ"
    : province && district && village
      ? "ເລືອກ ຫຼື ພິມສາຂາ"
      : province
        ? "ເລືອກ ຫຼື ພິມສາຂາ (ຕາມແຂວງ)"
        : "ເລືອກ ຫຼື ພິມສາຂາ";

  return (
    <SuggestTextField
      id={id}
      label="ສາຂາປາຍທາງ"
      value={value}
      onChange={onChange}
      options={options.data?.data ?? []}
      disabled={disabled || !carrierValue}
      placeholder={placeholder}
    />
  );
}
